import React from 'react'
import calendar from 'components/UI/Icons/calendar.png'

const Calendar = (props) => (
  <div style={{ padding: 5 }}><img alt="Calendario" style={{ maxWidth: '100%' }} src={calendar} /></div>
)

export default Calendar
